export const DEFAULT_COUNT_DIGITS = 3;
export const radius = 'radius';
